var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-outfit-container" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.noOutfitsForTheseFilters,
            expression: "!noOutfitsForTheseFilters"
          }
        ],
        ref: "swipeyBoy",
        staticClass: "generated-outfit-container",
        attrs: { id: "generated-outfit-container" }
      },
      [
        _c(
          "transition",
          {
            attrs: {
              name: "fade",
              mode: "out-in",
              duration: { enter: 600, leave: 450 }
            }
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showOutfitCard,
                    expression: "showOutfitCard"
                  }
                ],
                key: "1",
                ref: "swipeableEl",
                staticClass: "outfit-items-container swipeable",
                class: _vm.outfitContainerClass,
                style: _vm.outfitContainerStyle
              },
              [
                _c("outfit-card", {
                  ref: "outfitCard",
                  attrs: {
                    outfit: _vm.outfitCurrent,
                    handleProductClk: _vm.handleVisitProduct,
                    swapProductClk: _vm.swapProductCb
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.swipeScore !== 0,
                        expression: "swipeScore !== 0"
                      }
                    ],
                    staticClass: "outfit-swipe-box",
                    style: _vm.outfitSwipeBoxStyle
                  },
                  [_c("h3", [_vm._v(_vm._s(_vm.outfitSwipeBoxText))])]
                )
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "transition",
          {
            attrs: {
              name: "fade",
              mode: "out-in",
              duration: { enter: 600, leave: 450 }
            }
          },
          [
            _c("loader", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.showOutfitCard,
                  expression: "!showOutfitCard"
                }
              ],
              attrs: { message: "Loading outfit" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "outfit-card-placeholder" })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.noOutfitsForTheseFilters,
            expression: "noOutfitsForTheseFilters"
          }
        ],
        staticClass: "no-outfits-match-container"
      },
      [
        _c("h1", { staticClass: "no-outfits-match" }, [
          _vm._v("No Outfits Match These Filters")
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7840c6bf", { render: render, staticRenderFns: staticRenderFns })
  }
}